<template>
    <div>
        <div class="shipment-hscroll__inner">
            <!-- Delayed Packing Lists Side Panel -->
            <DelayedPackingLists
                :value="showPackingListTable"
                :user="user"
                :delayedPackingListsLoading="delayedPackingListsLoading"
                :delayedPackingLists="delayedPackingLists"
                :woClasificationsData="woClasificationsData"
                @openPackingList="openPackingList"
                @input="showPackingListTable = $event"
                @handleUpdateScheduledFor="handleUpdateScheduledFor"
            />
            <v-col class="py-0 my-0 calendar-scroll-container mt-4">
                <v-sheet class="py-0 my-0" height="75vh">
                    <v-toolbar flat class="mt-n6 my-0">
                        <!-- Toggle Delayed Packing Lists Panel -->
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    small
                                    color="primary"
                                    class="mr-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="
                                        showPackingListTable = !showPackingListTable
                                    "
                                >
                                    <v-icon>{{
                                        showPackingListTable
                                            ? 'mdi-chevron-left'
                                            : 'mdi-chevron-right'
                                    }}</v-icon>
                                </v-btn>
                            </template>
                            <span>{{
                                showPackingListTable
                                    ? 'Hide Delayed Packing Lists'
                                    : 'Show Delayed Packing Lists'
                            }}</span>
                        </v-tooltip>
                        <v-btn
                            outlined
                            class="mr-4"
                            color="grey darken-2"
                            @click="setToday"
                            small
                        >
                            Today
                        </v-btn>

                        <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="prev"
                        >
                            <v-icon small>
                                mdi-chevron-left
                            </v-icon>
                        </v-btn>

                        <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="next"
                        >
                            <v-icon small>
                                mdi-chevron-right
                            </v-icon>
                        </v-btn>

                        <v-toolbar-title class="text-subtitle-1">
                            {{ calendarTitle }}
                        </v-toolbar-title>

                        <v-spacer></v-spacer>
                        <!-- Color Legend Info Button -->
                        <v-menu
                            bottom
                            left
                            :close-on-content-click="false"
                            offset-y
                            max-width="250"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="mr-2"
                                    color="grey darken-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-information-outline</v-icon>
                                </v-btn>
                            </template>
                            <v-card class="pa-3" min-width="200">
                                <v-card-title
                                    class="pa-0 pb-2 text-subtitle-1 font-weight-bold"
                                >
                                    Color Guide
                                </v-card-title>
                                <v-card-text class="pa-0">
                                    <div
                                        v-for="(item, index) in colorGuide"
                                        :key="index"
                                        class="d-flex align-center mb-2"
                                    >
                                        <div
                                            :style="
                                                `width: 12px; height: 12px; border-radius: 50%; background-color: ${item.color};`
                                            "
                                            class="mr-3"
                                        ></div>
                                        <span class="text-body-2">
                                            <span class="font-weight-bold"
                                                >{{ item.colorName }}:</span
                                            >
                                            {{ item.value }}
                                        </span>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-menu>
                        <v-btn
                            rounded
                            class="mr-2"
                            color="success"
                            @click="exportToExcel"
                            :disabled="visibleEventsCount === 0 || loading"
                            small
                        >
                            <v-icon left small>mdi-microsoft-excel</v-icon>
                            EXPORT EXCEL
                        </v-btn>
                        <v-btn
                            rounded
                            class="mr-2"
                            color="success"
                            @click="exportCalendarExcel"
                            :disabled="
                                visibleEventsCount === 0 ||
                                    loading ||
                                    type === 'month'
                            "
                            small
                        >
                            <v-icon left small>mdi-calendar-export</v-icon>
                            EXPORT CALENDAR
                        </v-btn>
                        <v-btn
                            rounded
                            class="mr-2"
                            color="primary"
                            @click="tableDialog = true"
                            :disabled="visibleEventsCount === 0 || loading"
                            small
                        >
                            <v-icon left small>mdi-table</v-icon>
                            VIEW TABLE
                        </v-btn>
                        <v-btn
                            rounded
                            class="mr-2"
                            color="primary"
                            @click="mergeDialog = true"
                            :disabled="events.length < 2 || loading"
                            small
                        >
                            MERGE EVENTS
                        </v-btn>

                        <v-menu bottom right small>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    outlined
                                    color="grey darken-2"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <span>{{ typeToLabel[type] }}</span>

                                    <v-icon right>
                                        mdi-menu-down
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="type = 'day'">
                                    <v-list-item-title>Day</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="type = 'week'">
                                    <v-list-item-title>Week</v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="type = 'month'">
                                    <v-list-item-title>Month</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>
                    <v-toolbar flat class="mt-n4 my-0 pa-0">
                        <v-row no-gutters align="center" class="fill-width">
                            <v-col cols="12" md="1" class="px-2">
                                <!-- Status Filter -->
                                <v-autocomplete
                                    v-model="selectedStatusFilters"
                                    :items="statusFilters"
                                    label="Status"
                                    dense
                                    multiple
                                    chips
                                    deletable-chips
                                    small-chips
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="2" class="px-2">
                                <!-- Shipping Methods Filter -->
                                <v-autocomplete
                                    v-model="selectedShippingFilters"
                                    :items="shippingFilters"
                                    label="Shipping Methods"
                                    dense
                                    multiple
                                    chips
                                    deletable-chips
                                    small-chips
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>

                            <!-- <v-col cols="12" md="2" class="px-2">
                                <v-autocomplete
                                    v-model="selectedDestinationFilters"
                                    :items="destinationFilters"
                                    label="Destinations"
                                    dense
                                    multiple
                                    chips
                                    small-chips
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col> -->

                            <v-col cols="12" md="2" class="px-2">
                                <!-- Project Filter -->
                                <v-text-field
                                    v-model="projectFilterText"
                                    label="Project"
                                    dense
                                    hide-details
                                    clearable
                                >
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" md="2" class="px-2">
                                <!-- Classifications Filter -->
                                <v-autocomplete
                                    v-model="selectedClassificationFilters"
                                    :items="classificationFilters"
                                    label="Classifications"
                                    dense
                                    multiple
                                    chips
                                    deletable-chips
                                    small-chips
                                    hide-details
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="1" class="px-2">
                                <!-- Project Manager Filter -->
                                <v-checkbox
                                    v-model="showOnlyMyProjects"
                                    label="Only my projects"
                                    dense
                                    hide-details
                                    color="primary"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="1" class="px-2">
                                <!-- Important Filter -->
                                <v-checkbox
                                    v-model="showOnlyImportant"
                                    label="Only important"
                                    dense
                                    hide-details
                                    color="red"
                                >
                                    <template v-slot:label>
                                        <span class="d-flex align-center">
                                            <v-icon
                                                small
                                                color="red"
                                                class="mr-1"
                                            >
                                                mdi-flag
                                            </v-icon>
                                            Only important
                                        </span>
                                    </template>
                                </v-checkbox>
                            </v-col>
                            <v-col cols="12" md="2" class="d-flex justify-end">
                                <v-card
                                    class="pt-3 mb-3 mr-3"
                                    max-width="250px"
                                    height="40px"
                                >
                                    <v-card-text
                                        class="d-flex my-0 py-0 mx-0 px-0"
                                        width="100%"
                                    >
                                        <v-chip
                                            class="mb-1 mt-n1 mx-2 pt-0 white--text"
                                            color="
                                            primary
                                        "
                                            label
                                            :style="{ height: '25px' }"
                                        >
                                            <v-icon center small>
                                                mdi-package
                                            </v-icon>
                                        </v-chip>
                                        <div class="mb-1 mt-n1 pt-0 mr-2">
                                            <div
                                                class="d-flex mr-0 pr-0 text-capitalize"
                                            >
                                                <span class="text-h7"
                                                    >Containers:
                                                    {{
                                                        visibleEventsCount
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-toolbar>
                    <v-progress-linear
                        class="mt-n4"
                        v-if="loading"
                        indeterminate
                        color="primary"
                    />

                    <v-calendar
                        v-show="type === 'month'"
                        ref="calendar"
                        v-model="focus"
                        color="primary"
                        type="month"
                        :events="filteredEvents"
                        :event-color="getEventColor"
                        :event-ripple="false"
                        @click:event="showEvent"
                        @click:more="viewDay"
                        @click:date="viewDay"
                        @change="updateDateRange"
                    />

                    <div
                        v-if="type === 'week' || type === 'day'"
                        class="shipment-day-board"
                    >
                        <div
                            class="shipment-day-board__columns"
                            :class="{
                                'shipment-day-board__columns--day':
                                    type === 'day',
                            }"
                        >
                            <div
                                v-for="day in visibleBoardDays"
                                :key="day.dayKey"
                                class="shipment-day-column"
                                :class="{
                                    'shipment-day-column--today': day.isToday,
                                    'shipment-day-column--drag-over':
                                        dragOverDayKey === day.dayKey,
                                }"
                                @dragover.prevent="
                                    onBoardDayDragOver(day.dayKey, $event)
                                "
                                @dragleave="onBoardDayDragLeave(day.dayKey)"
                                @drop="onBoardDayDrop(day.dayKey, $event)"
                            >
                                <div class="shipment-day-column__header">
                                    <div
                                        class="text-caption text-uppercase font-weight-medium"
                                    >
                                        {{ day.weekdayLabel }}
                                    </div>
                                    <div
                                        class="text-subtitle-2 font-weight-bold"
                                    >
                                        {{ day.dateLabel }}
                                    </div>
                                    <v-chip
                                        x-small
                                        label
                                        class="mt-1"
                                        color="primary"
                                        text-color="white"
                                    >
                                        {{ day.events.length }} PL
                                    </v-chip>
                                </div>

                                <div class="shipment-day-column__list">
                                    <v-card
                                        v-for="holiday in day.holidays"
                                        :key="'holiday-' + holiday.name"
                                        class="mb-2 shipment-pl-card shipment-pl-card--holiday"
                                        color="error"
                                        dark
                                        flat
                                    >
                                        <v-card-text class="py-2 px-3">
                                            <div
                                                class="text-caption font-weight-bold"
                                            >
                                                {{ holiday.name }}
                                            </div>
                                        </v-card-text>
                                    </v-card>

                                    <v-tooltip
                                        v-for="event in day.events"
                                        :key="event.id"
                                        right
                                        open-on-hover
                                        :disabled="
                                            !event.elements ||
                                                !Array.isArray(
                                                    event.elements
                                                ) ||
                                                event.elements.length === 0
                                        "
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-card
                                                class="mb-2 shipment-pl-card"
                                                :class="{
                                                    'shipment-pl-card--dragging':
                                                        dragEvent &&
                                                        dragEvent.id ===
                                                            event.id,
                                                    'shipment-pl-card--on-dark': isEventCardDark(
                                                        event
                                                    ),
                                                }"
                                                :color="getEventColor(event)"
                                                :dark="isEventCardDark(event)"
                                                flat
                                                v-bind="attrs"
                                                v-on="on"
                                                :draggable="
                                                    canDragBoardEvent(event)
                                                "
                                                @dragstart="
                                                    onBoardDragStart(
                                                        event,
                                                        $event
                                                    )
                                                "
                                                @dragend="onBoardDragEnd"
                                                @click="
                                                    openBoardEvent(
                                                        event,
                                                        $event
                                                    )
                                                "
                                            >
                                                <v-card-text
                                                    class="py-2 px-3 shipment-pl-card__body"
                                                >
                                                    <v-badge
                                                        v-if="
                                                            event.elements &&
                                                                event.elements
                                                                    .length > 1
                                                        "
                                                        :content="
                                                            event.elements
                                                                .length
                                                        "
                                                        color="red"
                                                        overlap
                                                        class="shipment-pl-card__badge"
                                                    />
                                                    <v-icon
                                                        v-if="
                                                            hasImportantPackingList(
                                                                event
                                                            )
                                                        "
                                                        color="red"
                                                        small
                                                        class="shipment-pl-card__flag"
                                                    >
                                                        mdi-flag
                                                    </v-icon>
                                                    <div
                                                        class="shipment-pl-card__line shipment-pl-card__line--container"
                                                    >
                                                        <span
                                                            class="shipment-pl-card__label"
                                                            >Container:</span
                                                        >
                                                        <span
                                                            class="shipment-pl-card__value"
                                                            >{{
                                                                event.container ||
                                                                    ''
                                                            }}</span
                                                        >
                                                    </div>
                                                    <div
                                                        v-for="(element,
                                                        idx) in event.elements"
                                                        :key="idx"
                                                        class="shipment-pl-card__block"
                                                    >
                                                        <div
                                                            class="shipment-pl-card__line"
                                                        >
                                                            <span
                                                                class="shipment-pl-card__label"
                                                                >Project:</span
                                                            >
                                                            <span
                                                                class="shipment-pl-card__value"
                                                                >{{
                                                                    element.project
                                                                        ? `${element.project.reference} - ${element.project.name}`
                                                                        : '-'
                                                                }}</span
                                                            >
                                                        </div>
                                                        <div
                                                            class="shipment-pl-card__line"
                                                        >
                                                            <span
                                                                class="shipment-pl-card__label"
                                                                >Packing
                                                                List:</span
                                                            >
                                                            <span
                                                                class="shipment-pl-card__value"
                                                                >{{
                                                                    element
                                                                        .packingList
                                                                        .code
                                                                }}</span
                                                            >
                                                        </div>
                                                        <div
                                                            class="shipment-pl-card__line"
                                                        >
                                                            <span
                                                                class="shipment-pl-card__label"
                                                                >Work
                                                                Orders:</span
                                                            >
                                                            <span
                                                                class="shipment-pl-card__value"
                                                                >{{
                                                                    element
                                                                        .packingList
                                                                        .selectedWorkOrders
                                                                        ? element.packingList.selectedWorkOrders
                                                                              .map(
                                                                                  wo =>
                                                                                      wo.code
                                                                              )
                                                                              .join(
                                                                                  ', '
                                                                              )
                                                                        : ''
                                                                }}</span
                                                            >
                                                        </div>
                                                        <div
                                                            v-if="
                                                                element.project &&
                                                                    element
                                                                        .project
                                                                        .country &&
                                                                    element.project.country.toLowerCase() !=
                                                                        companyCountry
                                                            "
                                                            class="shipment-pl-card__line"
                                                        >
                                                            <span
                                                                class="shipment-pl-card__label"
                                                                >Destination
                                                                Country:</span
                                                            >
                                                            <span
                                                                class="shipment-pl-card__value"
                                                                >{{
                                                                    element
                                                                        .project
                                                                        .country
                                                                }}</span
                                                            >
                                                        </div>
                                                        <v-divider
                                                            v-if="
                                                                event.elements &&
                                                                    idx <
                                                                        event
                                                                            .elements
                                                                            .length -
                                                                            1
                                                            "
                                                            class="my-2"
                                                            :dark="
                                                                isEventCardDark(
                                                                    event
                                                                )
                                                            "
                                                            style="border-style: dashed;"
                                                        />
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </template>
                                        <div
                                            class="pa-2"
                                            style="max-width: 320px;"
                                        >
                                            <div
                                                class="text-subtitle-2 font-weight-bold mb-2"
                                            >
                                                Work orders:
                                            </div>
                                            <ul class="text-body-2 mb-0">
                                                <li
                                                    v-for="(line,
                                                    lineIdx) in getWorkOrdersTooltipLines(
                                                        event
                                                    )"
                                                    :key="lineIdx"
                                                >
                                                    {{ line }}
                                                </li>
                                            </ul>
                                        </div>
                                    </v-tooltip>

                                    <div
                                        v-if="
                                            !day.events.length &&
                                                !day.holidays.length
                                        "
                                        class="text-caption grey--text text-center py-6"
                                    >
                                        No shipments
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-sheet>
            </v-col>

            <v-dialog
                v-model="mergeDialog"
                :retain-focus="false"
                persistent
                width="1300px"
            >
                <MergeDialog
                    v-if="mergeDialog"
                    :events="events"
                    :user="user"
                    @close="mergeDialog = false"
                    @mergeConfirmed="mergeConfirmed"
                />
            </v-dialog>
            <v-dialog
                v-model="selectedOpen"
                :retain-focus="false"
                persistent
                fullscreen
            >
                <EventDetails
                    v-if="selectedOpen"
                    :event="selectedEvent"
                    :user="user"
                    :users="users"
                    :projects="projects"
                    @close="selectedOpen = false"
                    @packingListUpdated="handlePackingListUpdated"
                    @packingListDeleted="handlePackingListDeleted"
                />
            </v-dialog>
            <v-dialog v-model="tableDialog" :retain-focus="false" persistent>
                <ShipmentTable
                    :filteredEvents="filteredEvents"
                    :dateRange="dateRange"
                    :companyCountry="companyCountry"
                    @close="tableDialog = false"
                    @exportExcel="exportToExcel"
                />
            </v-dialog>
            <v-dialog
                v-model="packingListDetailForm"
                :retain-focus="false"
                persistent
                fullscreen
            >
                <PackingForm
                    v-if="packingListDetailForm && selectedPackingListOrder"
                    :project="selectedPackingListProject"
                    :original-order="selectedPackingListOrder"
                    :onlySuggested="!createPackingListPermission"
                    @close="closePackingList"
                    @replacePackingList="replacePackingList"
                />
            </v-dialog>
            <v-dialog
                v-model="processPackingListDetail"
                :retain-focus="false"
                persistent
                fullscreen
            >
                <ProcessPackingPending
                    v-if="
                        processPackingListDetail &&
                            selectedPackingListOrder &&
                            selectedPackingListOrder.status === 'pending'
                    "
                    :original-order="selectedPackingListOrder"
                    :project="selectedPackingListProject"
                    :onlySuggested="!createPackingListPermission"
                    @replacePackingList="replacePackingList"
                    @close="closePackingList"
                />
                <ProcessPackingScheduled
                    v-if="
                        processPackingListDetail &&
                            selectedPackingListOrder &&
                            selectedPackingListOrder.status === 'scheduled'
                    "
                    :original-order="selectedPackingListOrder"
                    :project="selectedPackingListProject"
                    :onlySuggested="!createPackingListPermission"
                    @replacePackingList="replacePackingList"
                    @close="closePackingList"
                />
                <ProcessPackingReferred
                    v-if="
                        processPackingListDetail &&
                            selectedPackingListOrder &&
                            selectedPackingListOrder.status === 'referred'
                    "
                    :original-order="selectedPackingListOrder"
                    :project="selectedPackingListProject"
                    :onlySuggested="!createPackingListPermission"
                    @replacePackingList="replacePackingList"
                    @close="closePackingList"
                />
                <ProcessPackingShipped
                    v-if="
                        processPackingListDetail &&
                            selectedPackingListOrder &&
                            selectedPackingListOrder.status === 'shipped'
                    "
                    :original-order="selectedPackingListOrder"
                    :project="selectedPackingListProject"
                    :onlySuggested="!createPackingListPermission"
                    @replacePackingList="replacePackingList"
                    @close="closePackingList"
                />
            </v-dialog>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import API from '@/services/api'
import Holidays from 'date-holidays'
import * as XLSX from 'xlsx/xlsx.mjs'
import { buildWorkOrdersAndBomsString } from '@/utils/packingListCodes'
const { v4: uuidv4 } = require('uuid')
export default {
    name: 'ShipmentCalendar',
    components: {
        MergeDialog: () =>
            import('@/components/ShipmentPlanner/MergeDialog.vue'),
        EventDetails: () =>
            import('@/components/ShipmentPlanner/EventDetails.vue'),
        ShipmentTable: () =>
            import('@/components/ShipmentPlanner/ShipmentTable.vue'),
        DelayedPackingLists: () =>
            import('@/components/ShipmentPlanner/DelayedPackingLists.vue'),
        PackingForm: () => import('@/components/Packing/PackingForm.vue'),
        ProcessPackingPending: () =>
            import('@/components/Packing/ProcessPackingPending.vue'),
        ProcessPackingScheduled: () =>
            import('@/components/Packing/ProcessPackingScheduled.vue'),
        ProcessPackingReferred: () =>
            import('@/components/Packing/ProcessPackingReferred.vue'),
        ProcessPackingShipped: () =>
            import('@/components/Packing/ProcessPackingShipped.vue'),
    },

    data: () => ({
        events: [],

        statusFilters: ['Completed', 'Requested', 'In Progress'],
        selectedStatusFilters: [],
        shippingFilters: ['Air Shipments'],
        selectedShippingFilters: [],
        destinationFilters: ['National', 'Export'],
        selectedDestinationFilters: [],
        classificationFilters: ['Nacional', 'Exportación', 'ES'],
        projectFilterText: '',
        selectedClassificationFilters: [],
        showOnlyMyProjects: false,
        showOnlyImportant: false,
        dragEvent: null,
        focus: '',
        type: 'week',
        typeToLabel: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
        },
        selectedEvent: {},
        selectedOpen: false,
        loading: true,
        companyCountry: 'colombia',
        colombianHolidays: [],
        mergeDialog: false,
        tableDialog: false,
        isDragging: false,
        visibleEventsCount: 0,
        dateRange: {},
        currentMonth: null,
        loadedMonths: [],
        packingLists: [],
        delayedPackingLists: [],
        woClasificationsData: {},
        showPackingListTable: false,
        packingListDetailForm: false,
        processPackingListDetail: false,
        selectedPackingListOrder: null,
        selectedPackingListProject: null,
        openingPackingList: false,
        colorGuide: [
            {
                colorName: 'Grey',
                value: 'Requested',
                color: '#9e9e9e',
            },
            {
                colorName: 'Yellow',
                value: 'Export',
                color: '#F9A825',
            },
            {
                colorName: 'Blue',
                value: 'National',
                color: '#1976d2',
            },
            {
                colorName: 'Purple',
                value: 'Air Shipments',
                color: '#918cbb',
            },
            {
                colorName: 'Green',
                value: 'Completed',
                color: '#4caf50',
            },
            {
                colorName: 'Red',
                value: 'Holidays',
                color: '#f44336',
            },
        ],
        delayedPackingListsLoading: false,
        woCodesToQuery: [],
        user: {},
        editPermission: false,
        boardAnchor: moment().format('YYYY-MM-DD'),
        dragOverDayKey: null,
    }),

    computed: {
        filteredEvents() {
            const events = this.events.filter(event => {
                if (!event.elements) {
                    return true
                }

                // For non-holiday events
                const pl = event.elements[0].packingList

                // Check project manager filter first
                if (this.showOnlyMyProjects) {
                    const isMyProject = event.elements.some(
                        element =>
                            element.project &&
                            element.project.projectManager === this.user?.id
                    )
                    if (!isMyProject) {
                        return false
                    }
                }

                // Check important filter
                if (this.showOnlyImportant) {
                    const hasImportantPL = event.elements.some(
                        element =>
                            element.packingList &&
                            element.packingList.important === true
                    )
                    if (!hasImportantPL) {
                        return false
                    }
                }

                // Check if ANY filters are selected across all categories
                const hasAnyFilters =
                    this.selectedStatusFilters.length > 0 ||
                    this.selectedShippingFilters.length > 0 ||
                    this.selectedDestinationFilters.length > 0 ||
                    this.selectedClassificationFilters.length > 0 ||
                    (this.projectFilterText &&
                        this.projectFilterText.trim() !== '') ||
                    this.showOnlyMyProjects ||
                    this.showOnlyImportant

                // If no filters selected at all, show everything
                if (!hasAnyFilters) {
                    return true
                }

                // Check status filters
                let statusMatch = true
                if (this.selectedStatusFilters.length > 0) {
                    statusMatch = false
                    if (
                        pl.status === 'completed' &&
                        this.selectedStatusFilters.includes('Completed')
                    ) {
                        statusMatch = true
                    }
                    if (
                        !pl.scheduledFor &&
                        this.selectedStatusFilters.includes('Requested')
                    ) {
                        statusMatch = true
                    }
                    if (
                        pl.status === 'inProgress' &&
                        this.selectedStatusFilters.includes('In Progress')
                    ) {
                        statusMatch = true
                    }
                }

                // Check air shipment filter
                let shippingMatch = true
                if (this.selectedShippingFilters.length > 0) {
                    shippingMatch = false
                    if (
                        pl.airShipment &&
                        this.selectedShippingFilters.includes('Air Shipments')
                    ) {
                        shippingMatch = true
                    }
                }

                // Check destination filters
                let destinationMatch = true
                if (this.selectedDestinationFilters.length > 0) {
                    destinationMatch = false
                    if (event.elements && event.elements[0].project?.country) {
                        const country = event.elements[0].project.country.toLowerCase()

                        if (
                            country === this.companyCountry &&
                            this.selectedDestinationFilters.includes('National')
                        ) {
                            destinationMatch = true
                        }
                        if (
                            country !== this.companyCountry &&
                            this.selectedDestinationFilters.includes('Export')
                        ) {
                            destinationMatch = true
                        }
                    }
                }

                // Check project filter (text search on reference and name)
                let projectMatch = true
                const projectSearch =
                    this.projectFilterText && this.projectFilterText.trim()
                if (projectSearch) {
                    const searchLower = projectSearch.toLowerCase()
                    projectMatch = event.elements.some(element => {
                        if (!element.project) return false
                        const ref = (element.project.reference || '')
                            .toString()
                            .toLowerCase()
                        const name = (element.project.name || '').toLowerCase()
                        return (
                            ref.includes(searchLower) ||
                            name.includes(searchLower)
                        )
                    })
                }

                // Check classifications filter
                let classificationMatch = true
                if (this.selectedClassificationFilters.length > 0) {
                    const selectedClassificationsLower = this.selectedClassificationFilters.map(
                        classification =>
                            (classification || '')
                                .toString()
                                .trim()
                                .toLowerCase()
                    )
                    classificationMatch = event.elements.some(element => {
                        const packingListClassifications =
                            element.packingList?.clasifications
                        if (!Array.isArray(packingListClassifications)) {
                            return false
                        }

                        return packingListClassifications.some(
                            classification => {
                                const classificationLower = (
                                    classification || ''
                                )
                                    .toString()
                                    .trim()
                                    .toLowerCase()
                                return selectedClassificationsLower.includes(
                                    classificationLower
                                )
                            }
                        )
                    })
                }

                // All selected filters must match
                return (
                    statusMatch &&
                    shippingMatch &&
                    destinationMatch &&
                    projectMatch &&
                    classificationMatch
                )
            })

            this.setVisibleEventsCount(events)

            return events
        },
        calendarTitle() {
            if (this.type === 'month' && this.$refs.calendar) {
                return this.$refs.calendar.title
            }
            const anchor = moment(this.boardAnchor)
            if (this.type === 'day') {
                return anchor.format('dddd, MMMM D, YYYY')
            }
            const start = anchor.clone().startOf('week')
            const end = anchor.clone().endOf('week')
            if (start.year() === end.year()) {
                return `${start.format('MMM D')} – ${end.format('MMM D, YYYY')}`
            }
            return `${start.format('MMM D, YYYY')} – ${end.format(
                'MMM D, YYYY'
            )}`
        },
        visibleBoardDays() {
            if (this.type !== 'week' && this.type !== 'day') {
                return []
            }
            const anchor = moment(this.boardAnchor)
            const dayCount = this.type === 'day' ? 1 : 7
            const rangeStart =
                this.type === 'day'
                    ? anchor.clone().startOf('day')
                    : anchor.clone().startOf('week')
            const days = []

            for (let i = 0; i < dayCount; i++) {
                const dayMoment = rangeStart.clone().add(i, 'day')
                const dayKey = dayMoment.format('YYYY-MM-DD')
                const events = this.filteredEvents
                    .filter(event => {
                        if (!event.elements || !event.start) {
                            return false
                        }
                        return (
                            moment(event.start).format('YYYY-MM-DD') === dayKey
                        )
                    })
                    .sort((a, b) => this.compareBoardEvents(a, b))

                const holidays = this.filteredEvents.filter(event => {
                    if (!event.isHoliday || !event.start) {
                        return false
                    }
                    return moment(event.start).format('YYYY-MM-DD') === dayKey
                })

                days.push({
                    dayKey,
                    weekdayLabel: dayMoment.format('ddd'),
                    dateLabel: dayMoment.format('D MMM'),
                    isToday: dayMoment.isSame(moment(), 'day'),
                    events,
                    holidays,
                })
            }

            return days
        },
        createPackingListPermission() {
            return !!this.user?.permissions?.includes('createPackingList')
        },
    },

    watch: {
        type() {
            if (this.type === 'month') {
                this.$nextTick(() => {
                    if (this.$refs.calendar) {
                        this.$refs.calendar.checkChange()
                    }
                })
            } else {
                this.syncBoardDateRange()
            }
        },
        boardAnchor() {
            if (this.type !== 'month') {
                this.syncBoardDateRange()
            }
        },
        focus: {
            handler(newFocus) {
                const newYear = newFocus
                    ? new Date(newFocus).getFullYear()
                    : new Date().getFullYear()

                if (this.currentHolidayYear !== newYear) {
                    this.currentHolidayYear = newYear
                    this.fetchColombianHolidays(newYear)
                }
            },
            immediate: true,
        },
    },

    async mounted() {
        try {
            this.loading = true
            this.delayedPackingListsLoading = true

            this.syncBoardDateRange()
            this.$nextTick(() => {
                if (this.$refs.calendar) {
                    this.$refs.calendar.checkChange()
                }
            })
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            if (user.permissions.includes('updateWOProcesses')) {
                this.editPermission = true
            }
            this.projects = await API.getLiteProjects({ all: true })
            const {
                data: { users },
            } = await API.getLiteUsers()
            this.users = users

            // Load delayed packing lists
            const delayedPackingLists = await API.getDelayedPackingLists()
            this.delayedPackingLists = delayedPackingLists || []

            // add the work orders of delayed packing lists to the woCodesToQuery
            this._addToWoCodesToQuery(delayedPackingLists)

            // get the classifications based on the woCodesToQuery
            await this.getWoClasifications(delayedPackingLists)

            this.currentMonth = moment().format('YYYY-MM')
            const queryMonth = moment()
                .subtract(1, 'month')
                .format('YYYY-MM')
            await this.getPackingLists(queryMonth)
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,

                message: error.message,
            })
        } finally {
            this.loading = false
            this.delayedPackingListsLoading = false
        }
    },

    methods: {
        ...mapMutations(['setErrorItems']),

        resetDragState() {
            this.dragEvent = null
            this.isDragging = false
        },

        getEventColor(event) {
            //event types
            //- Holidays -> Red
            if (!event.elements) {
                return 'error'
            } //- PL completed -> Green
            if (event.elements[0].packingList.status == 'completed') {
                return 'success'
            } //- PL with requested shipment date only -> Gray
            if (!event.elements[0].packingList.scheduledFor) {
                return '#6c6c6c'
            } //- Air shipment -> Purple
            if (event.elements[0].packingList.airShipment) {
                return '#918cbb'
            } //- National PL -> Blue
            if (
                event.elements[0].project.country?.toLowerCase() ==
                this.companyCountry
            ) {
                return 'primary'
            } //- Export PL -> Yellow
            if (
                event.elements[0].project.country?.toLowerCase() !=
                this.companyCountry
            ) {
                return '#F9A825'
            }
        },

        viewDay({ date }) {
            this.focus = date
            this.boardAnchor = date
            this.type = 'day'
            this.syncBoardDateRange()
        },

        setToday() {
            this.focus = ''
            this.boardAnchor = moment().format('YYYY-MM-DD')
            if (this.type === 'month' && this.$refs.calendar) {
                this.$refs.calendar.checkChange()
            } else {
                this.syncBoardDateRange()
            }
        },

        prev() {
            if (this.type === 'month') {
                this.$refs.calendar.prev()
                return
            }
            const unit = this.type === 'day' ? 'day' : 'week'
            this.boardAnchor = moment(this.boardAnchor)
                .subtract(1, unit)
                .format('YYYY-MM-DD')
            this.syncBoardDateRange()
        },

        next() {
            if (this.type === 'month') {
                this.$refs.calendar.next()
                return
            }
            const unit = this.type === 'day' ? 'day' : 'week'
            this.boardAnchor = moment(this.boardAnchor)
                .add(1, unit)
                .format('YYYY-MM-DD')
            this.syncBoardDateRange()
        },

        syncBoardDateRange() {
            if (this.type === 'month') {
                return
            }

            const anchor = moment(this.boardAnchor)
            const start =
                this.type === 'day'
                    ? anchor.clone().startOf('day')
                    : anchor.clone().startOf('week')
            const end =
                this.type === 'day'
                    ? anchor.clone().endOf('day')
                    : anchor.clone().endOf('week')

            this.updateDateRange({
                start: { date: start.format('YYYY-MM-DD') },
                end: { date: end.format('YYYY-MM-DD') },
            })
        },

        isEventCardDark(event) {
            const color = this.getEventColor(event)
            return color !== '#F9A825' && color !== '#9e9e9e'
        },

        compareBoardEvents(a, b) {
            const orderA = this.getEventStackOrder(a)
            const orderB = this.getEventStackOrder(b)
            if (orderA !== orderB) {
                return orderA - orderB
            }
            const codeA = a.elements?.[0]?.packingList?.code || ''
            const codeB = b.elements?.[0]?.packingList?.code || ''
            return codeA.localeCompare(codeB)
        },

        getEventStackOrder(event) {
            if (!event?.start) {
                return 0
            }
            if (event.start instanceof Date) {
                return event.start.getHours() * 60 + event.start.getMinutes()
            }
            return 0
        },

        canDragBoardEvent(event) {
            if (!event || event.isHoliday || !event.elements) {
                return false
            }
            if (
                event.elements.some(
                    e => e.packingList && e.packingList.status === 'completed'
                )
            ) {
                return false
            }
            if (
                !this.user.permissions.includes('updateWOProcesses') &&
                event.elements.some(
                    e => e.project && e.project.projectManager !== this.user.id
                )
            ) {
                return false
            }
            return true
        },

        onBoardDragStart(event, e) {
            if (!this.canDragBoardEvent(event)) {
                e.preventDefault()
                return
            }
            this.isDragging = true
            this.dragEvent = event
            if (e.dataTransfer) {
                e.dataTransfer.effectAllowed = 'move'
                e.dataTransfer.setData('text/plain', event.id)
            }
        },

        onBoardDragEnd() {
            this.dragOverDayKey = null
            this.isDragging = false
        },

        onBoardDayDragOver(dayKey) {
            if (this.dragEvent) {
                this.dragOverDayKey = dayKey
            }
        },

        onBoardDayDragLeave(dayKey) {
            if (this.dragOverDayKey === dayKey) {
                this.dragOverDayKey = null
            }
        },

        async onBoardDayDrop(dayKey, e) {
            e.preventDefault()
            this.dragOverDayKey = null
            if (!this.dragEvent) {
                return
            }
            await this.applyRescheduleToDate(this.dragEvent, dayKey)
            this.resetDragState()
        },

        openBoardEvent(event, nativeEvent) {
            if (this.isDragging) {
                return
            }
            this.showEvent({
                nativeEvent: nativeEvent || {
                    target: null,
                    stopPropagation() {},
                },
                event,
            })
        },

        async applyRescheduleToDate(dragEvent, newDate) {
            if (!dragEvent.elements) {
                return
            }

            for (const element of dragEvent.elements) {
                if (
                    element.packingList &&
                    this.user.permissions.includes('updateWOProcesses')
                ) {
                    const currentScheduledFor = element.packingList.scheduledFor
                    if (currentScheduledFor !== newDate) {
                        await this.updateScheduledFor({
                            projectId: element.project.id,
                            packingListId: element.packingList.id,
                            scheduledFor: newDate,
                        })
                        element.packingList.scheduledFor = newDate
                    }
                } else if (
                    element.packingList &&
                    !this.user.permissions.includes('updateWOProcesses') &&
                    this.user.id == element.project.projectManager
                ) {
                    const currentRequestedDate =
                        element.packingList.requestedShipmentDate
                    if (currentRequestedDate !== newDate) {
                        await this.updateScheduledFor({
                            projectId: element.project.id,
                            packingListId: element.packingList.id,
                            requestedShipmentDate: newDate,
                            scheduledFor: null,
                        })
                        element.packingList.requestedShipmentDate = newDate
                    }
                }
            }

            const today = moment().format('YYYY-MM-DD')
            const processedIds = new Set()

            for (const element of dragEvent.elements) {
                const packingList = element?.packingList
                if (!packingList?.id || processedIds.has(packingList.id)) {
                    continue
                }
                processedIds.add(packingList.id)

                const deliveryDate =
                    packingList.scheduledFor ||
                    packingList.requestedShipmentDate
                if (!deliveryDate) {
                    continue
                }

                const deliveryDateStr = moment(deliveryDate).format(
                    'YYYY-MM-DD'
                )
                const isOnOrAfterToday = deliveryDateStr >= today
                const delayedIndex = this.delayedPackingLists.findIndex(
                    pl => pl.id === packingList.id
                )

                if (isOnOrAfterToday) {
                    if (delayedIndex !== -1) {
                        this.delayedPackingLists.splice(delayedIndex, 1)
                    }
                } else if (delayedIndex !== -1) {
                    this.delayedPackingLists.splice(delayedIndex, 1, {
                        ...this.delayedPackingLists[delayedIndex],
                        ...packingList,
                    })
                } else {
                    this.delayedPackingLists.push({ ...packingList })
                }
            }

            this.setEvents()
        },

        async showEvent({ nativeEvent, event }) {
            if (this.isDragging) {
                return
            }

            // avoid showing holidays
            if (event.isHoliday) {
                return
            }

            this.selectedEvent = event
            requestAnimationFrame(() =>
                requestAnimationFrame(() => (this.selectedOpen = true))
            )

            nativeEvent.stopPropagation()
        },

        setEvents() {
            if (this.projects) {
                const eventsByDay = {}

                this.packingLists.forEach(packingList => {
                    let dateString =
                        packingList.scheduledFor ||
                        packingList.requestedShipmentDate

                    if (packingList.shippedOn) {
                        dateString = moment
                            .unix(
                                packingList.shippedOn.seconds ||
                                    packingList.shippedOn._seconds
                            )
                            .format('YYYY-MM-DD')
                    }

                    if (dateString) {
                        const date = new Date(dateString)

                        const dayKey = date.toISOString().slice(0, 10)

                        if (!eventsByDay[dayKey]) {
                            eventsByDay[dayKey] = []
                        }

                        eventsByDay[dayKey].push({
                            packingList: packingList,
                            name: packingList.code,
                            date: date,
                            project: this.projects.find(
                                p => p.id == packingList.projectId
                            ),
                        })
                    }
                })

                this.events = []

                for (const dayKey in eventsByDay) {
                    let currentDayEvents = eventsByDay[dayKey]
                    currentDayEvents.sort((a, b) =>
                        a.name.localeCompare(b.name)
                    )
                    let dayEvents = []
                    currentDayEvents.forEach(event => {
                        let eventIndex = -1
                        if (
                            event.packingList &&
                            event.packingList.container &&
                            event.packingList.container != ''
                        ) {
                            eventIndex = dayEvents.findIndex(
                                e =>
                                    e.container ==
                                        event.packingList.container &&
                                    e.elements[0].packingList.scheduledFor ==
                                        event.packingList.scheduledFor
                            )
                        }

                        if (eventIndex > -1) {
                            dayEvents[eventIndex].elements.push({
                                name: event.name,
                                packingList: event.packingList,
                                project: event.project,
                            })
                        } else {
                            dayEvents.push({
                                id: uuidv4(),
                                container: event.packingList.container || '',
                                elements: [
                                    {
                                        name: event.name,
                                        packingList: event.packingList,
                                        project: event.project,
                                    },
                                ],
                            })
                        }
                    })

                    let sortIndex = 0
                    dayEvents.forEach(event => {
                        const start = new Date(dayKey + 'T00:00:00')
                        start.setMinutes(sortIndex)
                        event.start = start
                        event.end = start
                        event.dayKey = dayKey
                        sortIndex += 1
                    })
                    this.events.push(...dayEvents)
                }

                this.colombianHolidays.forEach(holiday => {
                    const holidayDate = new Date(holiday.date)

                    const startOfDay = new Date(holidayDate)
                    startOfDay.setHours(0, 0, 0, 0)

                    const endOfDay = new Date(holidayDate)
                    endOfDay.setHours(23, 59, 59, 999)

                    this.events.push({
                        container: '',
                        name: `Festivo: ${holiday.name}`,
                        isHoliday: true,
                        start: startOfDay,
                        end: endOfDay,
                        type: 'holiday',
                        details: ` ${holiday.name}` || holiday.note,
                    })
                })
            }
        },

        async fetchColombianHolidays(year) {
            this.loading = true
            try {
                const hd = new Holidays('CO')
                this.colombianHolidays = hd.getHolidays(year)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
                this.colombianHolidays = []
            } finally {
                this.loading = false
            }
        },

        async updateScheduledFor(params) {
            try {
                this.loading = true
                await API.updatePackingList(params)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        mergeConfirmed({
            newContainer,
            newAirShipment,
            newScheduledFor,
            selectedPackingLists,
        }) {
            this.mergeDialog = false
            let executeUpdate = false
            selectedPackingLists.forEach(pl => {
                const foundIndex = this.packingLists.findIndex(
                    packingList => packingList.id === pl
                )
                if (foundIndex !== -1) {
                    this.packingLists[foundIndex].container = newContainer
                    this.packingLists[foundIndex].airShipment = newAirShipment
                    this.packingLists[foundIndex].scheduledFor = newScheduledFor
                    executeUpdate = true
                }
            })
            if (executeUpdate) {
                this.setEvents()
            }
        },

        updateDateRange({ start, end }) {
            const visibleMonth = moment(start.date).format('YYYY-MM')
            const previousMonth = moment(visibleMonth)
                .subtract(1, 'month')
                .format('YYYY-MM')
            if (this.currentMonth !== visibleMonth) {
                this.currentMonth = visibleMonth
                //verify the load of the visible month
                if (!this.loadedMonths.includes(visibleMonth)) {
                    this.loadedMonths.push(visibleMonth)
                    this.getPackingLists(visibleMonth)
                }
                // load new packing lists for the previous month of the visible one
                if (!this.loadedMonths.includes(previousMonth)) {
                    this.loadedMonths.push(previousMonth)
                    this.getPackingLists(previousMonth)
                }
            }
            this.dateRange = { start, end }
        },
        async getPackingLists(month) {
            try {
                this.loading = true
                const newPackingLists = await API.getCalendarPackingLists({
                    startDate: moment
                        .unix(
                            moment(month)
                                .startOf('month')
                                .unix()
                        )
                        .format('YYYY-MM-DD'),
                    endDate: moment
                        .unix(
                            moment(month)
                                .endOf('month')
                                .unix()
                        )
                        .format('YYYY-MM-DD'),
                })

                // add the work orders of new packing lists to the woCodesToQuery
                this._addToWoCodesToQuery(newPackingLists)

                // get the classifications based on the woCodesToQuery
                await this.getWoClasifications()

                const existingIds = new Set(
                    this.packingLists.map(packingList => packingList.id)
                )
                const mergedPackingLists = [...this.packingLists]
                newPackingLists.forEach(packingList => {
                    if (!existingIds.has(packingList.id)) {
                        existingIds.add(packingList.id)

                        // add clasifications
                        packingList.clasifications = []
                        if (
                            packingList.selectedWorkOrders &&
                            packingList.selectedWorkOrders.length > 0
                        ) {
                            packingList.selectedWorkOrders.forEach(wo => {
                                // only add clasifications if they are not already in the list
                                if (
                                    this.woClasificationsData[wo.code] &&
                                    !packingList.clasifications.includes(
                                        this.woClasificationsData[wo.code]
                                    )
                                ) {
                                    packingList.clasifications.push(
                                        this.woClasificationsData[wo.code]
                                    )
                                }
                            })
                        }
                        mergedPackingLists.push(packingList)
                    }
                })
                this.packingLists = mergedPackingLists
                this.setEvents()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        setVisibleEventsCount(events) {
            const visibleEvents = events.filter(event => {
                const eventDay = moment(event.start).format('YYYY-MM-DD')
                const startDay = moment(this.dateRange.start.date).format(
                    'YYYY-MM-DD'
                )
                const endDay = moment(this.dateRange.end.date).format(
                    'YYYY-MM-DD'
                )

                const isInRange = eventDay >= startDay && eventDay <= endDay
                return isInRange
            })

            this.visibleEventsCount = visibleEvents.length
        },

        hasImportantPackingList(event) {
            if (!event.elements || event.elements.length === 0) {
                return false
            }
            return event.elements.some(element => {
                return (
                    element.packingList &&
                    element.packingList.important === true
                )
            })
        },

        getWorkOrdersTooltipLines(event) {
            const lines = []

            ;(event?.elements || []).forEach(element => {
                const selectedWorkOrders =
                    element?.packingList?.selectedWorkOrders || []

                selectedWorkOrders.forEach(wo => {
                    if (!wo?.code) return

                    const code = wo.code
                    const originCodes = wo.originWorkOrders || []

                    if (originCodes.length > 0) {
                        lines.push(`${code} (${originCodes.join('. ')})`)
                    } else {
                        lines.push(code)
                    }
                })
            })

            return lines
        },

        exportCalendarExcel() {
            try {
                if (this.type === 'month') return

                // Get visible events in current date range
                const visibleEvents = this.filteredEvents.filter(event => {
                    if (!event.elements) return false
                    const eventDay = moment(event.start).format('YYYY-MM-DD')
                    const startDay = moment(this.dateRange.start.date).format(
                        'YYYY-MM-DD'
                    )
                    const endDay = moment(this.dateRange.end.date).format(
                        'YYYY-MM-DD'
                    )
                    return eventDay >= startDay && eventDay <= endDay
                })

                // Group elements by date
                const elementsByDate = {}
                visibleEvents
                    .sort((a, b) => new Date(a.start) - new Date(b.start))
                    .forEach(event => {
                        const dateKey = moment(event.start).format('YYYY-MM-DD')
                        if (!elementsByDate[dateKey]) {
                            elementsByDate[dateKey] = []
                        }
                        event.elements.forEach(el => {
                            const project = el.project
                                ? `${el.project.reference} - ${el.project.name}`
                                : '-'
                            const workOrders = el.packingList
                                ?.selectedWorkOrders
                                ? el.packingList.selectedWorkOrders
                                      .map(wo => wo.code)
                                      .join(', ')
                                : '-'
                            const destination = el.project?.country
                                ? el.project.country.toLowerCase() ===
                                  this.companyCountry
                                    ? 'National'
                                    : 'Export'
                                : '-'
                            const shippingType = el.packingList?.airShipment
                                ? 'Air Shipment'
                                : 'Standard'
                            const important = el.packingList?.important
                                ? 'Yes'
                                : 'No'

                            elementsByDate[dateKey].push(
                                [
                                    `Container: ${event.container ||
                                        '-'}, PL: ${el.packingList?.code ||
                                        '-'}`,
                                    `Project: ${project}`,
                                    `Status: ${el.packingList?.status ||
                                        '-'}, Shipping: ${shippingType}, Destination: ${destination}`,
                                    `WOs: ${workOrders}, Important: ${important}`,
                                ].join('\n')
                            )
                        })
                    })

                const sortedDates = Object.keys(elementsByDate).sort()
                if (sortedDates.length === 0) return

                const maxRows = Math.max(
                    ...sortedDates.map(d => elementsByDate[d].length)
                )

                const header = sortedDates.map(d =>
                    moment(d).format('ddd DD MMM YYYY')
                )
                const dataRows = []
                for (let i = 0; i < maxRows; i++) {
                    dataRows.push(
                        sortedDates.map(d => elementsByDate[d][i] || '')
                    )
                }

                const ws = XLSX.utils.aoa_to_sheet([header, ...dataRows])

                // Apply wrapText to all cells so \n line breaks are respected
                const range = XLSX.utils.decode_range(ws['!ref'])
                for (let R = range.s.r; R <= range.e.r; ++R) {
                    for (let C = range.s.c; C <= range.e.c; ++C) {
                        const addr = XLSX.utils.encode_cell({ r: R, c: C })
                        if (ws[addr]) {
                            ws[addr].s = {
                                alignment: {
                                    wrapText: true,
                                    vertical: 'top',
                                },
                            }
                        }
                    }
                }

                ws['!cols'] = sortedDates.map(() => ({ wch: 50 }))

                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, 'Shipments Calendar')

                const fileName = `shipments_calendar_${this.type}_${moment(
                    this.dateRange.start.date
                ).format('YYYY-MM-DD')}.xlsx`
                XLSX.writeFile(wb, fileName, { cellStyles: true })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },

        handlePackingListUpdated({ packingListId, important }) {
            // Find and update the packing list in local state
            const packingListIndex = this.packingLists.findIndex(
                pl => pl.id === packingListId
            )
            if (packingListIndex !== -1) {
                this.packingLists[packingListIndex].important = important
                // Rebuild calendar events with updated data
                this.setEvents()
            }
        },

        handlePackingListDeleted({ packingListId }) {
            const idx = this.packingLists.findIndex(
                pl => pl.id === packingListId
            )
            if (idx !== -1) {
                this.packingLists.splice(idx, 1)
            }
            const previousEventId = this.selectedEvent?.id
            this.setEvents()
            if (this.selectedOpen && previousEventId) {
                const updated = this.events.find(e => e.id === previousEventId)
                if (updated?.elements?.length) {
                    this.selectedEvent = updated
                } else {
                    this.selectedOpen = false
                    this.selectedEvent = {}
                }
            }
        },

        isScheduledForOnOrAfterToday(scheduledFor) {
            if (!scheduledFor) return false

            const scheduledDate =
                typeof scheduledFor === 'string'
                    ? moment(scheduledFor).format('YYYY-MM-DD')
                    : moment(scheduledFor).format('YYYY-MM-DD')

            if (!scheduledDate) return false

            const today = moment().format('YYYY-MM-DD')
            return scheduledDate >= today
        },

        handleUpdateScheduledFor({ packingListId, scheduledFor }) {
            // Find and update the packing list in local state
            const packingListIndex = this.packingLists.findIndex(
                pl => pl.id === packingListId
            )
            if (packingListIndex !== -1) {
                this.packingLists[packingListIndex].scheduledFor = scheduledFor
                // Rebuild calendar events with updated data
                this.setEvents()
            }

            const delayedPackingListIndex = this.delayedPackingLists.findIndex(
                pl => pl.id === packingListId
            )
            if (delayedPackingListIndex !== -1) {
                if (this.isScheduledForOnOrAfterToday(scheduledFor)) {
                    // Delete from delayed packing lists
                    this.delayedPackingLists.splice(delayedPackingListIndex, 1)
                } else {
                    // Update the delayed packing list
                    this.delayedPackingLists.splice(
                        delayedPackingListIndex,
                        1,
                        {
                            ...this.delayedPackingLists[
                                delayedPackingListIndex
                            ],
                            scheduledFor,
                        }
                    )
                }
            }
        },

        exportToExcel() {
            try {
                // Get only the events visible in the current date range (day/week/month)
                const visibleEvents = this.filteredEvents.filter(event => {
                    if (!event.elements) return false // exclude holidays
                    const eventDay = moment(event.start).format('YYYY-MM-DD')
                    const startDay = moment(this.dateRange.start.date).format(
                        'YYYY-MM-DD'
                    )
                    const endDay = moment(this.dateRange.end.date).format(
                        'YYYY-MM-DD'
                    )
                    return eventDay >= startDay && eventDay <= endDay
                })
                visibleEvents.sort(
                    (a, b) => new Date(a.start) - new Date(b.start)
                )
                // Flatten events into rows
                const rows = []
                visibleEvents.forEach(event => {
                    event.elements.forEach(el => {
                        rows.push({
                            Date: moment(event.start).format('YYYY-MM-DD'),
                            Container: event.container || '-',
                            'Packing List': el.packingList?.code || '-',
                            Project: el.project
                                ? `${el.project.reference} - ${el.project.name}`
                                : '-',
                            Status: el.packingList?.status || '-',
                            'Shipping Type': el.packingList?.airShipment
                                ? 'Air Shipment'
                                : 'Standard',
                            Destination: el.project?.country
                                ? el.project.country.toLowerCase() ===
                                  this.companyCountry
                                    ? 'National'
                                    : 'Export'
                                : '-',
                            'Destination Country': el.project?.country || '-',
                            'Work Orders': el.packingList?.selectedWorkOrders
                                ? el.packingList.selectedWorkOrders
                                      .map(wo => wo.code)
                                      .join(', ')
                                : '-',
                            Important: el.packingList?.important ? 'Yes' : 'No',
                        })
                    })
                })

                const ws = XLSX.utils.json_to_sheet(rows)

                // AutoFilter (dropdowns en el header) y freeze de la primera fila
                ws['!autofilter'] = { ref: ws['!ref'] }
                ws['!freeze'] = { xSplit: 0, ySplit: 1 }

                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, 'Shipments')

                const fileName = `shipments_${this.type}_${moment(
                    this.dateRange.start.date
                ).format('YYYY-MM-DD')}.xlsx`
                XLSX.writeFile(wb, fileName)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        buildWorkOrdersAndBomsString,
        getPLStatus(pl, plProject) {
            const hasNoPackages = !pl.packages || pl.packages.length === 0
            const hasScheduledDate = pl.scheduledFor || pl.requestedShipmentDate
            const isInProgress = pl.status === 'inProgress'
            if (!hasNoPackages || !hasScheduledDate || !isInProgress) {
                return pl.status
            }
            const isDomesticShipping =
                plProject.country &&
                plProject.country.toLowerCase() === this.companyCountry
            if (pl.selectedWorkOrders) {
                return isDomesticShipping ? 'domesticShipping' : 'reserved'
            }
            if (!pl.selectedWorkOrders) {
                return isDomesticShipping
                    ? 'domesticShipping'
                    : 'reservedForProject'
            }
            return pl.status
        },
        formatPackingList(packingList, project) {
            packingList.selectedWorkOrdersAndBomsString = this.buildWorkOrdersAndBomsString(
                packingList
            )
            packingList.status = this.getPLStatus(packingList, project)
            packingList.netMass = this.calculateNetMass(packingList).toFixed(1)
            packingList.grossMass = this.calculateGrossMass(
                packingList
            ).toFixed(1)
        },
        calculateNetMass(pl) {
            return (
                pl.packages?.reduce((acc, pkg) => {
                    return (
                        acc +
                        (pkg.items?.reduce((itemAcc, item) => {
                            return itemAcc + Number(item.packingMass || 0)
                        }, 0) || 0)
                    )
                }, 0) || 0
            )
        },
        calculateGrossMass(pl) {
            const net = this.calculateNetMass(pl)
            const crates =
                pl.packages?.reduce((acc, pkg) => {
                    return acc + Number(pkg.packageDimensions?.mass || 0)
                }, 0) || 0
            return net + crates
        },
        findProjectForPackingList(projectId) {
            return this.projects?.find(p => p.id === projectId) || {}
        },
        async openPackingList(item) {
            try {
                this.loading = true

                if (this.openingPackingList) return
                this.openingPackingList = true

                const project = await API.getProject(item.projectId)
                const pl = _.cloneDeep(item)
                this.formatPackingList(pl, project)
                this.selectedPackingListProject = _.cloneDeep(project)
                this.selectedPackingListOrder = pl
                this.packingListDetailForm = false
                this.processPackingListDetail = false
                await this.$nextTick()

                const formStatuses = [
                    'inProgress',
                    'rejected',
                    'reserved',
                    'reservedForProject',
                    'domesticShipping',
                ]
                const processStatuses = [
                    'pending',
                    'scheduled',
                    'referred',
                    'shipped',
                ]
                if (formStatuses.includes(pl.status)) {
                    this.packingListDetailForm = true
                } else if (processStatuses.includes(pl.status)) {
                    this.processPackingListDetail = true
                } else {
                    this.setErrorItems({
                        source: this.$options.name,
                        message: `Status "${pl.status}" is not supported from this view.`,
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.openingPackingList = false
                this.loading = false
            }
        },
        closePackingList() {
            this.selectedPackingListOrder = null
            this.selectedPackingListProject = null
            this.packingListDetailForm = false
            this.processPackingListDetail = false
        },
        replacePackingList(packingList) {
            const index = this.packingLists.findIndex(
                p => p.id == packingList.id
            )
            if (index < 0) return
            this.packingLists.splice(index, 1, {
                ...this.packingLists[index],
                ...packingList,
            })

            const delayedIndex = this.delayedPackingLists.findIndex(
                p => p.id == packingList.id
            )
            if (delayedIndex !== -1) {
                const shouldRemoveFromDelayed = this.isScheduledForOnOrAfterToday(
                    packingList?.scheduledFor
                )

                if (shouldRemoveFromDelayed) {
                    // delete from delayed packing lists
                    this.delayedPackingLists.splice(delayedIndex, 1)
                } else {
                    // update the delayed packing list
                    this.delayedPackingLists.splice(delayedIndex, 1, {
                        ...this.delayedPackingLists[delayedIndex],
                        ...packingList,
                    })
                }
            }
            const plProject = this.findProjectForPackingList(
                this.packingLists[index].projectId
            )
            this.formatPackingList(this.packingLists[index], plProject)
            if (
                this.selectedPackingListOrder &&
                this.selectedPackingListOrder.id == packingList.id
            ) {
                const updated = _.cloneDeep({
                    ...this.selectedPackingListOrder,
                    ...packingList,
                })
                this.formatPackingList(
                    updated,
                    this.selectedPackingListProject || plProject
                )
                this.selectedPackingListOrder = updated
            }
            this.setEvents()
        },
        async getWoClasifications() {
            try {
                let newClasifications = []
                const requestedCodes = this.woCodesToQuery
                const normalizeCode = code =>
                    (code || '')
                        .toString()
                        .trim()
                        .toLowerCase()
                const existingCodesNormalized = new Set(
                    Object.keys(this.woClasificationsData).map(code =>
                        normalizeCode(code)
                    )
                )

                // only request the codes that are not already in the woClasificationsData
                const codesToRequest =
                    requestedCodes.filter(
                        code =>
                            typeof code === 'string' &&
                            code.trim() !== '' &&
                            !existingCodesNormalized.has(normalizeCode(code))
                    ) || []

                if (codesToRequest.length > 0) {
                    newClasifications = await API.getClasificationsPerWorkOrder(
                        {
                            codes: codesToRequest,
                        }
                    )
                    const updatedClasificationsData = {
                        ...this.woClasificationsData,
                    }
                    newClasifications.forEach(classification => {
                        if (!updatedClasificationsData[classification.code]) {
                            updatedClasificationsData[classification.code] =
                                classification.classification
                        }
                    })
                    this.woClasificationsData = updatedClasificationsData
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        _addToWoCodesToQuery(packingLists) {
            packingLists.forEach(packingList => {
                if (packingList.selectedWorkOrders) {
                    packingList.selectedWorkOrders.forEach(wo => {
                        const code = wo?.code
                        if (
                            typeof code === 'string' &&
                            code.trim() !== '' &&
                            !this.woCodesToQuery.includes(code)
                        ) {
                            this.woCodesToQuery.push(code)
                        }
                    })
                }
            })
        },
    },
}
</script>

<style scoped lang="scss">
.shipment-hscroll__inner {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    > * {
        flex: 0 0 auto;
    }
}

.calendar-scroll-container {
    min-width: 100%;
    flex: 0 0 auto !important;
}

.calendar-wrapper {
    display: flex;
    width: 100%;
    overflow: hidden;

    &.with-panel {
        .calendar-scroll-container {
            flex: 1;
            overflow-x: auto;
            overflow-y: hidden;
            min-width: 0;
        }
    }
}
.v-event-draggable {
    padding-left: 6px;
}

.v-event-timed {
    user-select: none;
    -webkit-user-select: none;
}

.v-event-drag-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4px;
    height: 4px;
    cursor: ns-resize;
    &::after {
        display: none;
        position: absolute;
        left: 50%;
        height: 4px;
        border-top: 1px solid white;
        border-bottom: 1px solid white;
        width: 16px;
        margin-left: -8px;
        opacity: 0.8;
        content: '';
    }

    &:hover::after {
        display: block;
    }
}
</style>

<style lang="scss">
.v-calendar-daily_head-day-label button {
    width: 25px !important;
    height: 25px !important;
    min-width: 25px !important;
    min-height: 25px !important;
}

// .v-calendar-daily__day-interval {
//     height: 60px !important;
// }

// .v-calendar-daily__pane {
//     height: 1440px !important;
// }

.v-calendar-daily__intervals-body {
    display: none;
}

// .v-calendar-daily__interval {
//     height: 60px !important;
// }

.v-calendar-daily__intervals-head {
    display: none;
}

.shipment-day-board {
    height: calc(75vh - 56px);
    overflow: hidden;
}

.shipment-day-board__columns {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 8px;
    padding: 4px 2px 8px;
}

.shipment-day-board__columns--day {
    .shipment-day-column {
        flex: 1;
        max-width: none;
        min-width: 280px;
    }
}

.shipment-day-column {
    flex: 0 0 260px;
    min-width: 260px;
    max-width: 320px;
    display: flex;
    flex-direction: column;
    background: #fafafa;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;

    &--today {
        border-color: var(--v-primary-base, #1976d2);
        box-shadow: 0 0 0 1px var(--v-primary-base, #1976d2);
    }

    &--drag-over {
        border-color: var(--v-success-base, #4caf50);
        background: #f1f8e9;
    }
}

.shipment-day-column__header {
    flex: 0 0 auto;
    padding: 10px 12px;
    background: #fff;
    border-bottom: 1px solid #e0e0e0;
    text-align: center;
}

.shipment-day-column__list {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 8px;
    min-height: 0;
}

.shipment-pl-card {
    cursor: pointer;
    transition: box-shadow 0.15s ease, opacity 0.15s ease;
    position: relative;

    &[draggable='true'] {
        cursor: grab;
    }

    &--dragging {
        opacity: 0.45;
    }

    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    }

    &__body {
        position: relative;
        font-size: 0.8125rem;
        line-height: 1.35;
    }

    &__line {
        margin-top: 4px;

        &--container {
            margin-top: 0;
            margin-bottom: 2px;
        }
    }

    &__block + &__block {
        margin-top: 6px;
        padding-top: 6px;
        border-top: 1px dashed rgba(0, 0, 0, 0.12);
    }

    &__label {
        font-weight: 700;
        margin-right: 4px;
    }

    &__value {
        font-weight: 400;
    }

    &--on-dark {
        .shipment-pl-card__body,
        .shipment-pl-card__label,
        .shipment-pl-card__value {
            color: #fafafa !important;
        }

        .shipment-pl-card__label {
            color: #ffffff !important;
        }

        .shipment-pl-card__block + .shipment-pl-card__block {
            border-top-color: rgba(255, 255, 255, 0.35);
        }
    }

    &:not(.shipment-pl-card--on-dark) {
        .shipment-pl-card__label {
            color: rgba(0, 0, 0, 0.87);
        }

        .shipment-pl-card__value {
            color: rgba(0, 0, 0, 0.72);
        }
    }

    &__badge {
        position: absolute !important;
        top: 8px;
        right: 8px;
        z-index: 1;
    }

    &__flag {
        position: absolute;
        bottom: 8px;
        right: 8px;
        z-index: 1;
        background: white;
        border-radius: 50%;
        padding: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
}
</style>
